<template>
  <div
    class="d-flex flex-column"
    style="flex: auto; overflow-y:auto; overflow-x: hidden;"
  >
    <div class="d-flex flex-row">
      <back-button></back-button>
      <div class="d-flex flex-column mb-4">
        <h4 class="text-primary">
          <b>Escolha a clínica</b> de sua preferência
        </h4>
        <small class="font-weight-bold">Selecione a clínica desejada</small>
      </div>
    </div>

    <loading-overlay v-if="isLoading" message="Carregando clínicas..." />

    <b-row v-else>
      <div
        class="col-12 col-lg-6 mb-4"
        v-for="clinica in clinicas"
        :key="clinica.id"
      >
        <div
          :class="{
            'border-primary': clinic_s && clinic_s.id === clinica.id
          }"
          class="custom-radio-wrapper align-items-start d-flex flex-row justify-content-between align-content-center"
        >
          <div class="custom-control custom-radio">
            <input
              type="radio"
              :value="clinica"
              :id="'clinica-' + clinica.id"
              @change="submit(clinica)"
              :checked="clinic_s && clinic_s.id === clinica.id"
              name="clinica"
              class="custom-control-input"
              @click="advance"
            />
            <label
              class="custom-control-label d-inline-flex flex-column"
              :for="'clinica-' + clinica.id"
            >
              <span class="text-primary text-uppercase">{{ clinica.nome }}</span>
              <span class="small">
                {{ clinica | clinicAddress }}
              </span>
            </label>
          </div>
          <div class="pl-3">
            <img
              :src="`${$serverHost}agendamentos/clinicas/${clinica.id}/logo`"
              id="logoimage"
              @error="placeholder"
              :alt="`Logotipo da clínica ${clinica.nome}`"
            />
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import BackButton from "@/components/back-button.vue";
import LoadingOverlay from "@/components/loading-overlay.vue";
import { generateTo } from "@/core/routerHelper.js";
import { mapGetters } from "vuex";
export default {
  name: "clinica",
  components: {
    BackButton, LoadingOverlay
  },
  methods: {
    placeholder(e) {
      e.target.src = require("../assets/images/clinic.png");
    },
    advance() {
      if (this.clinic_s && this.clinic_s.id) {
        this.submit(this.clinic_s);
      }
    },
    submit(clinica) {
      clinica.stepId = 3;
      this.$store.dispatch("load_selected", clinica);
      this.$store.dispatch("set_to", {
        name: generateTo(4, this.$route),
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: this.$route.query.especialidade,
          clinica: this.clinic_s.id
        }
      });

      this.$router.push(this.$store.getters.to);
    }
  },
  computed: {
    ...mapGetters("loading", ["isLoading"]),
    clinic_s() {
      return this.$store.getters.get_selected[2];
    },
    clinicas() {
      return this.$store.getters.get_clinics;
    },
    organizationId() {
      return this.$route.params.organizationId;
    },
    healthPlan() {
      return this.$route.query.convenio;
    },
    specialty() {
      return this.$route.query.especialidade;
    },
    isBackNav() {
      return this.$store.state.Config.goBack;
    }
  },
  async mounted() {
    let payload = {
      params: {
        organizationId: this.$route.params.organizationId
      },
      url: `${this.$serverHost}agendamentos/clinicas`,
      type: this.$route.fullPath.includes("exame") ? "exame" : "consulta"
    };

    await this.$store.dispatch("load_clinics", payload);

    if (this.clinicas.length === 1 && !this.isBackNav) {
      this.submit(this.clinicas[0]);
    }

    this.$store.dispatch("setGoBack", false);
    this.$store.dispatch("set_actual", this.$route.fullPath);
    this.$store.dispatch("set_from", {
      name: generateTo(2, this.$route),
      params: { organizationId: this.$route.params.organizationId },
      query: { convenio: this.$route.query.convenio }
    });

    if (this.clinic_s.nome) {
      this.$store.dispatch("set_to", {
        name: generateTo(4, this.$route),
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: this.$route.query.especialidade,
          clinica: this.clinic_s.id
        }
      });
    } else {
      this.$store.dispatch("set_to", "");
    }
  }
};
</script>

<style>
#logoimage {
  object-fit: contain;
  height: 120px;
  width: 120px;
  float: right;
}
</style>
